export default {
    path : "factory-item-all",
    name : "factory-item-all",
    meta : {
        title : "全部项目"
    },
    component: () => import('@/pages/factory/all/Index'),
    redirect: {
        name : "factory-item-all-whole"
    },
    children: [
        {
            path: 'all',
            name: 'factory-item-all-whole',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'recent',
            name: 'factory-item-all-recent',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'atme',
            name: 'factory-item-all-atme',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'meat',
            name: 'factory-item-all-meat',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'reply',
            name: 'factory-item-all-reply',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'search',
            name: 'factory-item-all-search',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path : 'detail/:id',
            name : 'factory-item-all-detail',
            metal: {
                title : '项目详细信息',
            },
            component: () => import('@/pages/itemCommon/Detail'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/factory/allitem/index.js